<template>
  <div class="dt-loading-main">
    <div class="dt-loading-center">
      <h4>
        <div class="dt-loading-ellipsis">
          <span class="dt-loading-spot"></span>
        </div>
      </h4>
    </div>
  </div>
</template>

<script>
  export default {
    name: "datedu-loading",
    data () {
      return {}
    }
  }
</script>

<style lang="scss" scoped>
  .dt-loading-main {
    padding-top   : 20px;
    text-align    : center;
    width         : 100%;
    margin-bottom : 20px;
    .dt-loading-center {
      margin-left       : 50%;
    }
    h4 {
      font-size   : 14px;
      font-weight : 400;
    }
    .dt-loading-ellipsis {
      position      : relative;
      height        : 8px;
      border-radius : 4px;
      .dt-loading-spot {
        position      : absolute;
        left          : 13px;
        height        : 8px;
        width         : 8px;
        background    : #3E73F6;
        border-radius : 4px;
      }
      &:before {
        -webkit-animation : loading-ellipsis-b 1s ease-in-out infinite;
        animation         : loading-ellipsis-b 1s ease-in-out infinite;
        background        : #3E73F6;
        opacity           : .4;
      }
      &:after {
        -webkit-animation : loading-ellipsis-a 1s ease-in-out infinite;
        animation         : loading-ellipsis-a 1s ease-in-out infinite;
        background        : #3E73F6;
        opacity           : .8;
      }
    }

    .dt-loading-ellipsis:after, .dt-loading-ellipsis:before {
      content       : "";
      display       : block;
      position      : absolute;
      height        : 8px;
      width         : 8px;
      border-radius : 4px;
    }
  }

  @-webkit-keyframes loading-ellipsis-b {
    0%, 100% {
      left              : 0;
      -webkit-transform : scale(1.1);
      transform         : scale(1.1)
    }

    50% {
      left              : 25px;
      -webkit-transform : scale(1);
      transform         : scale(1)
    }
  }

  @keyframes loading-ellipsis-b {
    0%, 100% {
      left              : 0;
      -webkit-transform : scale(1.1);
      transform         : scale(1.1)
    }

    50% {
      left              : 25px;
      -webkit-transform : scale(1);
      transform         : scale(1)
    }
  }

  @-webkit-keyframes loading-ellipsis-a {
    0%, 100% {
      left              : 25px;
      -webkit-transform : scale(1.1);
      transform         : scale(1.1)
    }

    50% {
      left              : 0;
      -webkit-transform : scale(1);
      transform         : scale(1)
    }
  }

  @keyframes loading-ellipsis-a {
    0%, 100% {
      left              : 25px;
      -webkit-transform : scale(1.1);
      transform         : scale(1.1)
    }

    50% {
      left              : 0;
      -webkit-transform : scale(1);
      transform         : scale(1)
    }
  }

</style>
